import { VALIDATIONS, buildValidation } from '~utils/inputValidations';

import { FIELDS } from './constants';

export const validationSchema = buildValidation({
  [FIELDS.apartment]: VALIDATIONS.apartmentDetails,
  [FIELDS.note]: VALIDATIONS.placesAddress
});

export const getStoreInfoByDay = (businessHours, currentDay) =>
  businessHours?.find(({ day }) => day === currentDay);
